export default __webpack_public_path__ + "static/media/Video.686286c0.jpg";